import React, { Component } from 'react';
import { Alert } from '../../../js/ComponentManager'
import { Big3Common, bootstrap } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능:도매 공지사항 작성 화면
 * 세부설명:
*/

export class StoreMsgReg extends Component {
    static displayName = StoreMsgReg.name;

    constructor(props) {
        super(props);
        this.state = {
            Noti_Title: "",
            Noti_Contt: "",
            Push_Yn: false,
            Title: "",
            Content: "",
            RegisterSuccess: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handleMove_Click = this.handleMove_Click.bind(this);
    }
    //초기화
    componentDidMount() {
    }
    handleChange(event) {
        const target = event.target;
        let tagId = target.id;
        const value = target.type === 'checkbox' ? target.checked : target.value;  
        this.setState({ [tagId]: value });
        return false;
    }
    async handleSave_Click() {
        if (this.state.Noti_Title.trim().length === 0) {
            this.setState({ "Content": "제목을 등록하여 주세요." });
        }
        else if (this.state.Noti_Contt.trim().length === 0) {
            this.setState({ "Content": "내용을 등록하여 주세요." });
        }
        else {
            try {

                let Data = await Big3Common.Post("api/MyPage/Notice/RegisterNotice_Mgt", {
                    noti_title: this.state.Noti_Title,
                    noti_contt: this.state.Noti_Contt,
                    push_yn: this.state.Push_Yn === true ? "Y" : "N"
                });

                if (Data.codeName === Big3Common.ResultCode.Success) {
                    this.setState({ Content: Data.message, RegisterSuccess: true });
                }
                else {
                    this.setState({ Content: Data.message });
                }
            }
            catch (e) {
                console.log("handleSave :", e);
            }
        }

        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
        return false;

    }
    handleMove_Click() {
        if (this.state.RegisterSuccess) {
            this.props.RenderComponent("StoreMsg");
        }
    }
    render() {
        return (
            <div>
                <div className="container_box p_b_margin d_padding">
                    <div className="notice_write_title">
                        <input type="text"
                            className="form-control"
                            id="Noti_Title"
                            placeholder="제목을 입력해 주세요."
                            maxLength="50"
                            onChange={this.handleChange }
                            value={this.state.Noti_Title}
                        />
                        <div className="title_delete pointer" onClick={(e) => this.setState({ Noti_Title:""})}></div>
                    </div>
                    <div className="notice_write_content">
                        <textarea
                            className="form-control"
                            id="Noti_Contt"
                            maxLength="500"
                            placeholder="공지사항을 작성해 주세요.&#13;&#10;(월 5회 거래처에 알림 메시지를 보낼 수 있습니다.)"
                            onChange={this.handleChange}
                            value={this.state.Noti_Contt}
                        ></textarea>
                    </div>
                    <div className="alarm_check">
                        <input className="form-check-input"
                            type="checkbox"
                            onChange={this.handleChange}
                            id="Push_Yn"
                            checked={this.state.Push_Yn}
                        />
                        <label className="form-check-label">
                            거래처 알림 보내기
                        </label>
                    </div>
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handleSave_Click }>완료</button>
                </div>
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="공지사항 입력 알림"
                    AlertClick={this.handleMove_Click}
                />
            </div>
        ); 
    }
}
